import Heading from "@/components/Heading";
import { ColorBox } from "devextreme-react";

type Props = {
  isSecondary: boolean;
  value: string;
  setValue: (value: string) => void;
};

const ChangeColorInput = ({ isSecondary, value, setValue }: Props) => {
  return (
    <div className="flex items-center gap-2">
      <Heading text={isSecondary ? "Secondary color" : "Primary color"} className="min-w-[140px]" />
      <ColorBox value={value} onValueChanged={(e) => setValue(e.value)} />
    </div>
  );
};

export default ChangeColorInput;
